import axios from "axios";
import { Message, Loading } from 'element-ui';
import { $getCookie, $setCookie } from "@/utils/utils";
//顶部进度条
// import NProgress from "nprogress";
// import "nprogress/nprogress.css";
import store from "@/store";
import Qs from "qs";

// axios请求相关处理
let httpNum = 0; //接口请求次数
let loading = null;
//需要配置域名
let baseUrl = '';
if (location.host == 'sjbxtest.cailian.net'){
  baseUrl = 'https://zljtinsurancetestapi.cailian.net';
} else if (location.host == 'sjbxsx.cailian.net'){
  baseUrl = 'https://zljtinsurancesxapi.cailian.net';
} else if (location.host == 'sjbxds.cailian.net'){
  baseUrl = 'https://zljtinsurancedsapi.cailian.net';
} else if (location.host == 'sjbxdsgs.cailian.net'){
  baseUrl = 'https://zljtinsurancedsgsapi.cailian.net';
} else {
  baseUrl = process.env.VUE_APP_BASE_URL;
}

// 创建 axios 实例
const $axios = axios.create({
  // API 请求的默认前缀
  baseURL: baseUrl,
 // timeout: 6000 // 请求超时时间
});

// 请求出错处理
const errorHandler = error => {
  httpNum--; // 每次接口请求失败，次数减一
  if (!httpNum) loading.close(); //最后一次接口请求完毕，关闭弹窗

  // NProgress.done(); //关闭顶部进度条
  let result = error.response;
  if (result) {
    const data = result.data;
    // 从 Cookie 获取 token
    const token = $getCookie("token");
    if (result.status == 404) {
      Message.error("请求的接口不存在,请联系开发人员！");
    } else if (result.status == 500) {
      Message.error("系统异常,请联系开发人员！");
    } else if (result.status == 504) {
      Message.error("请求超时,请刷新重试！");
    } else if (result.status == 6011 && !(data.result && data.result.isLogin)) {
      Message.error("登录失效，请重新登录");
      if (token) {
        store.dispatch('user/Logout');
      }
    } else {
      Message.error("系统异常,请稍后重试！");
    }
  } else {
    Message.error("系统异常,请稍后重试！");
  }
  return Promise.reject(error);
};

// 请求头设置
$axios.interceptors.request.use(config => {
  if (!loading || !httpNum) {
    loading = Loading.service({
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0)'
    });
  }
  httpNum++; // 每次接口请求，次数加一

  config.headers["Content-Type"] = config.headers["Content-Type"] || "application/x-www-form-urlencoded";
  const token = $getCookie("token");
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  if (token) {
    config.headers["token"] = token;
  }
  // NProgress.start(); //打开顶部进度条
  //TODO 需要取值
  // let sendName = '';
  // if (config.method == 'post' ){
  //   sendName = 'data';
  // } else {
  //   sendName = "params";
  // }
  // if (config[sendName]){
  //   config[sendName].userId = JSON.parse(sessionStorage.getItem('user'))?.userId;
  //   config[sendName].sourceId = sessionStorage.getItem('sourceId');
  // } else {
  //   config[sendName] = {
  //     userId: JSON.parse(sessionStorage.getItem('user'))?.userId,
  //     sourceId: sessionStorage.getItem('sourceId')
  //   };
  // }
  config.headers['sourceId'] = sessionStorage.getItem('sourceId');
  config.headers['userId'] = JSON.parse(sessionStorage.getItem('user'))?.userId;
  config.headers['recordId'] = store.state.recordId || "";
  // 默认情况下，需要将请求参数封装成form-data格式
  config.headers["authorization"] = `Bearer ${$getCookie("token")}`;
  if (config.headers["Content-Type"] == "application/x-www-form-urlencoded") {
    config.data = Qs.stringify(config.data);
  }
  return config;
}, errorHandler);

// 相应头设置
$axios.interceptors.response.use(response => {
  httpNum--; // 每次接口请求失败，次数减一
  if (!httpNum) loading.close(); //最后一次接口请求完毕，关闭弹窗

  // NProgress.done(); //关闭顶部进度条
  if (response.data.code){
    let resCode = response.data.code;
    //对于埋点的接口 不需要反馈
    if (response.request.responseURL.indexOf('/recordPushCloud/recordPushData') > -1) return Promise.reject();
    // 如果返回结果的状态不是200，则统一执行error
    if (resCode != 200) {
      Message.error(response.data.msg || response.data.Message);
      return Promise.reject();
    }
  }

  // 如果登录以后，每次接口请求成功都要重置token过期时间
  $getCookie('token') && $setCookie("token", $getCookie('token'));

  return response.data;
}, errorHandler);

export default $axios;